/**
 * Expose les helpers de `format.js` comme méthodes de template, pour qu'une vue
 * n'ait pas à importer trente symboles un par un.
 *
 *   import formatMixin from './formatMixin'
 *   export default { mixins: [formatMixin], ... }
 *
 * Puis dans le template : {{ m3(r.m3_out) }}, {{ date(r.date_permit_expiry) }},
 * {{ parcelName(r) }}, {{ STATUS.label(r.status) }}…
 */
import fmt from './format'

export default {
  methods: {
    num: fmt.num,
    m3: fmt.m3,
    m3int: fmt.m3int,
    ron: fmt.ron,
    rate: fmt.rate,
    eur: fmt.eur,
    int: fmt.int,
    tonnes: fmt.tonnes,
    pct: fmt.pct,
    date: fmt.date,
    dateTime: fmt.dateTime,
    dateTimeRo: fmt.dateTimeRo,
    extensionNote: fmt.extensionNote,
    dateInput: fmt.dateInput,
    dateISO: fmt.dateISO,
    duration: fmt.duration,
    parcelName: fmt.parcelName,
    parcelLink: fmt.parcelLink,
    deadlineTone: fmt.deadlineTone,
    anomalies: fmt.anomalies
  },
  computed: {
    // Les cartes de libellés sont constantes : les exposer en computed évite de
    // les recréer à chaque rendu tout en les rendant lisibles dans le template.
    DASH: () => fmt.DASH,
    SOURCE: () => fmt.SOURCE,
    STATUS: () => fmt.STATUS,
    DECISION: () => fmt.DECISION,
    DEPOT_STATUS: () => fmt.DEPOT_STATUS,
    COST_TYPE: () => fmt.COST_TYPE,
    GAP: () => fmt.GAP,
    OPERATING_MODE: () => fmt.OPERATING_MODE
  }
}
